<template>
	<card type="cinc" class="ReCardServiceView lightTheme" :class="[{'card-warning':objService.STATUS == 'На контроле'}, {'card-danger':(objService.STATUS == 'Отказ' || objService._archive == 1 )}]" >
		<div class="specBtns">
			<el-tooltip content="История изменений" placement="top">
				<el-button class="no-border my-0"><base-button @click="GoToHistory()" type="primary" class="no-border btn-history" simple icon><i class="d-inline-block tim-ic ic-history "></i></base-button></el-button>
			</el-tooltip>
		</div>
		<!-- <div class="oneline d-flex mb-3 pr-3">
			<div class="col-md-6"><div class="BP-row pr-1"><h4 class="mb-1 mr-2">Оказываемая услуга</h4><h4 class="BP-id-serviceView ml-xs-0 mb-1">(ID услуги: {{objService.id}})</h4></div></div>
			<div class="col-md-6 pl-2"><p>{{objService.BP_NAME}}</p></div>
		</div> -->
		<!-- <h6 class="text-danger" v-if="objService.CHILD_SERVICES.length > 0">ЭТО РОДИТЕЛЬ</h6>
		<h6 class="text-danger" v-if="objService.PARENT_SERVICES.length > 0">ЭТО ЧАЙЛД</h6> -->
		<div class="oneline-serv mb-3 pr-3 justify-content-between">
			<h6 class="mr-3 mb-0">
				<span class="text-primary">Оказываемая услуга: </span>
				<span class="mb-0 ">{{objService.BP_NAME}} {{objService.BP_EXT_NAME}}
					(ID услуги: {{objService.id}}<span v-if="objService.lead_id !=''">, ID лида: {{objService.lead_id}}</span>
					<span v-if="clientId != objService.client_id">, клиент: <router-link :to="'/data/clients/id/'+objService.client_id">{{objService.client_id}}</router-link></span>)
				</span>
				

			</h6>
			<span v-if="objService.lead_id !=''" class="ml-0 mr-3 mt-1 mb-0 el-tag el-tag--small el-tag el-tag--plain el-tag--primary">из лида</span>
			<div v-if="objService.dt_expire && objService.dt_expire>'0000-00-00 00:00:00'" class="d-flex mr-5 align-items-baseline">
				<h4 class="mb-0 mr-2">Осталось времени</h4>
				<ReBackTimer :time="objService.dt_expire"/>
			</div>
		</div>
		
		
		
		<div class="oneline d-flex mb-3 pr-3" v-if="objService.PARENT_SERVICES.length > 0">
			<h6 class="mr-3 mb-0" v-for="parentService in objService.PARENT_SERVICES" :key="parentService.id">
				<span  class="text-primary">Родительская услуга: </span>
				<!-- <span class="mb-0 ml-2" v-if="objService.object_name && objService.object_name!=''">{{objService.object_name}} (ID услуги: {{parentService.id}})</span> -->
				<span class="mb-0 ml-2">{{parentService.BP_NAME}} {{parentService.BP_EXT_NAME}}  (ID услуги: {{parentService.id}})</span>
			</h6>	
		</div>

		<div class="oneline d-flex mb-md-2 mb-3" v-if="objService.BP_STAGES.data.length>0">	
			<div class="BPSTAGES-row ">
				<h6 class="text-primary mr-3 mb-0">Этапы услуги:</h6>	
				<div class="BPSTAGES" v-for="stage in objService.BP_STAGES.data" :key="stage.id"><p class="mb-0" :class="{'text-primary':stage.name == objService.STAGE_NAME }">{{stage.name}}</p></div>
			</div>
		</div>

		<div class="oneline d-flex mb-2" v-if="objService.agrm_number">
			<h6 class="d-inline-block mb-0">
				<ReAgrmInfo :info="objService"></ReAgrmInfo>
				<el-tooltip content="Отвязать договор" placement="top" v-if="(this.$GVO.my_profile.Support == 1 || this.$GVO.my_profile.adm == 1) && objService.STATUS != 'В архиве'" >
					<base-button @click="deleteAgrm(objService)" type="danger" class="no-border btn-history" simple icon><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>
				</el-tooltip>
			</h6>
		</div>

		<div class="service-container">

			<div class="service-row" v-if="objService.AgentIsWork==1">
				<h6 class="text-primary mr-3 mb-2 px-0">Ответственный: </h6>	
						
				<div class="row mx-0" v-if="!bIsAgentEdit">
					<div class="row-no-wrap">
						<p class="mb-0">{{objService.agent_name}}</p>
						<base-button v-show="objService.editable==1 && objService.STATUS !='Сделка закрыта' && objService.STATUS !='Отказ'" 						
							@click="GoToEdit('agent',objService.agent_id)"
							type="primary"
							class="no-border my-0"
							simple
							icon
						>
							<i class="d-inline-block tim-icons icon-pencil"></i>
						</base-button>

					</div>
				</div>
				<div class="mx-0 d-inline-flex flex-md-nowrap flex-wrap w-100 px-0" v-else>
					<div class="ReInputSearchDrop-container px-0">
					<ReInputSearchDrop
						:findId="'agent_id'"
						:placeholder="'Выбрать ответственного'"
						v-model="agent_model"
						:objApiMethod="{'obj':'staff' ,'flt':{'fio':''}}"
						:strApiMethodKey="'fio'"
						@change="onAgentChange"
					/>
					</div>
					<div class="editBtns" v-if="bIsAgentEdit">
						<base-button type="success" class="no-border my-0" simple icon @click="onSave">
							<i class="d-inline-block tim-icons icon-check-2"></i>
						</base-button>
						<base-button type="danger" class="no-border my-0" simple icon @click="onCancel">
							<i class="d-inline-block tim-icons icon-simple-remove"></i>
						</base-button>
					</div>
				</div>
			</div>

			<div class="service-row " v-else>
				<div class="row mx-0 mb-0" v-if="!bIsAgentEdit">
					<div class="row-no-wrap">
						<div class="text-danger mr-1"><i class="tim-icons text-danger icon-alert-circle-exc mr-1"></i>Сотрудник уволен. Смените ответственного.</div>
						<base-button v-show="objService.editable==1 && objService.STATUS !='Сделка закрыта' && objService.STATUS !='Отказ'"
							@click="GoToEdit('agent',objService.agent_id)"
							type="danger"
							class="no-border my-0"
							simple
							icon
						>
							<i class="d-inline-block tim-icons icon-pencil"></i>
						</base-button>
					</div>
				</div>
				<div class="mx-0 col-md-6 d-inline-flex px-0" v-else>
					<div class="col-8 px-0">
					<ReInputSearchDrop
						:findId="'agent_id'"
						:placeholder="'Выбрать ответсвенного'"
						v-model="agent_model"
						:objApiMethod="{'obj':'staff' ,'flt':{'fio':''}}"
						:strApiMethodKey="'fio'"
						@change="onAgentChange"
					/>
					</div>
					<div class="editBtns" v-if="bIsAgentEdit">
						<base-button type="success" class="no-border my-0" simple icon @click="onSave">
							<i class="d-inline-block tim-icons icon-check-2"></i>
						</base-button>
						<base-button type="danger" class="no-border my-0" simple icon @click="onCancel">
							<i class="d-inline-block tim-icons icon-simple-remove"></i>
						</base-button>
					</div>
				</div>
			</div>

			<div class="service-row " >
				<template v-if="!bServicePartnerEdit">
					<h6 class="text-primary mr-3 mb-0">Вид сделки: </h6>					
					<div class="row mx-0" v-if="typeof objService.SERVICES_PARTNER == 'undefined' || objService.SERVICES_PARTNER.length==0">
						<div class="row-no-wrap">
						<p>Личная</p>
						<base-button v-show="objService.editable==1" 						
								@click="GoToEdit('SERVICES_PARTNER',objService.id)"
								type="primary"
								class="no-border my-0"
								simple
								icon
							>
								<i class="d-inline-block tim-icons icon-pencil"></i>
						</base-button>
						</div>
					</div>
					<div class="row mx-0" v-else>
						<div class="row-no-wrap">
						<p>Совместная: <span v-for="(staff,sin) in objService.SERVICES_PARTNER">{{staff.agent_name}}<span v-if="sin<(objService.SERVICES_PARTNER.length-1)">, </span></span></p>
						<base-button v-show="objService.editable==1" 						
								@click="GoToEdit('SERVICES_PARTNER',objService.id)"
								type="primary"
								class="no-border my-0"
								simple
								icon
							>
								<i class="d-inline-block tim-icons icon-pencil"></i>
						</base-button>
						</div>
					</div>
				</template>
				<template v-else>
					<div class="row w-100">
						<label class="col-form-label col-md-12 formRequired"><span >Выберите вид сделки</span></label>
						<div class="form-group col-md-12">
							<ReSelectSovmestService 
								v-model="objSS"
								:placeholder="'Выбрать совместителей'"
								:objApiMethod="{'obj':'staff','flt':{'fio':''}}"
								:strApiMethodKey="'fio'"
							/>
						</div>
						<div class="pl-3">
							<button class="btn btn-simple btn-success mr-2" @click="SaveSovmestService()">Сохранить</button>
							<button class="btn btn-simple btn-danger" @click="CancelSovmestService()">Отмена</button>
						</div>
					</div>
				</template>
			</div>
			
			<div class="service-row align-items-center" v-if="objService.adsSourceName && objService.adsSourceName != ''">
				<h6 class="text-primary mr-3 mb-0">Рекламный источник: </h6>				
				<div><p class="mb-0">{{objService.adsSourceName}}</p></div>
			</div>
			<div class="service-row align-items-center" v-if="objService.lead_source && objService.lead_source != ''">
				<h6 class="text-primary mr-3 mb-0">Источник лида: </h6>				
				<div><p class="mb-0">{{objService.lead_source}}</p></div>
			</div>
			
			<!-- <div class="service-row align-items-center" v-if="objService.lead_id !=''">
				<h6 class="mr-3 mb-0">Услуга создана из лида</h6>
			</div> -->
			<div class="service-row align-items-center" v-if="objService.ServiceSourceType == 'cc'">
				<h6 class="mr-3 mb-0">Объект лида: </h6>
				<div class="" v-if="objService.object_name && objService.object_name!=''"><router-link :to="'/data/ColdCall/id/'+objService.ServiceSourceId">{{objService.object_name}}</router-link></div>
				<div class="" v-else><router-link :to="'/data/ColdCall/id/'+objService.ServiceSourceId">Посмотреть объект</router-link></div>
			</div>

			<div class="service-row align-items-center" v-if="objService.object_id != null && objService.object_id != ''">
				<h6 class="mr-3 mb-0">Объект: </h6>
				<div class="" v-if="objService.object_name && objService.object_name!=''"><router-link :to="'/data/module/mo/object/'+objService.object_id">{{objService.object_name}}</router-link></div>
				<div class="" v-else><router-link :to="'/data/module/mo/object/'+objService.object_id">Посмотреть объект</router-link></div>
			</div>
			

		
		
		<!-- <div class="oneline  d-flex mb-3" >
			<h4 class="col-md-6 mb-1">временная инфа, это </h4>
			<div class="col-md-6 "><a >{{objService.ServiceSourceId}}</a></div>
		</div> -->

		<!--
		<div class="oneline  d-flex mb-3" v-if="masPotrebnosti.length>0">
			<h4 class="col-md-6 mb-1">Потребности</h4>
			<div class="col-md-6 ">
				<div class="row-no-wrap">
					<p>{{masPotrebnosti.join(', ')}}</p>
					<base-button v-show="objService.editable==1" v-if="objService.STATUS!='На контроле' && objService.STATUS!='Сделка закрыта'"
						@click="GoToTaskEndEdit()" 
						type="primary"
						class="no-border ml-1"
						simple
						icon
					>
					<i class="d-inline-block tim-icons icon-pencil"></i>
					</base-button>
				</div>
			</div>
		</div>
		-->

			<ReClientNeeds class="mb-2" :objService="objService"/>

			<div class="" v-if="objService.SERVICES_CHECKLISTS.length > 0">
				<h6 class="mb-0">Чеклисты: </h6>
				<ul class="list-unstyled result-marker">
					<ChecklistResult v-for="checklist in objService.SERVICES_CHECKLISTS" :key="checklist.id" :checklist="checklist"/>
				</ul>
			</div>

			<!-- <div v-if="objService.extra_json && objService.extra_json !=''" class="itemchecklistStyles">
				<h6 class="text-primary mb-0" @click="offertaShowMe" style="cursor:pointer;">Какие-то новые чек-листы предложений оферты</h6>	
				<div v-if="offertaShow">
				<div v-for="itemchecklist in sellerServChecklist.CHECKLIST" :key="itemchecklist.id" style="border-bottom: 1px dashed rgb(1, 176, 224); margin-bottom: 15px;">
					
					<p>id чеклиста: {{ itemchecklist.id }}</p>	
					<p>service_id: {{ itemchecklist.service_id }}</p>	
					<p>task_id: {{ itemchecklist.task_id }}</p>	
					<a :href="'/data/clients/id/' + itemchecklist.client_id" >Клиент-покупатель? в общем это client_id № {{itemchecklist.client_id}}</a>
					
					<p>Время добавления: {{  $GVO.convertDateTimeFromMysql(itemchecklist.InsertTime)  }}</p>	
					<ul class="list-unstyled result-marker">
						<p>Поля fields в этом чек-листе</p>
						<li  v-for="field in itemchecklist.fields" :key="field.id">
							{{ field }}
						</li>
					</ul>	
				</div>	
				<span>Это приходит жсоном extra_json {{ objService.extra_json }}</span>		
				</div>	
				
			</div> -->
			<div v-if="this.serviceOffers && this.serviceOffers.length > 0" class="mb-2 itemchecklistStyles">
				<h6 class="text-primary mb-1" @click="offertaShowMe" style="cursor:pointer;">Чек-лист предложений оферты</h6>	
				<div v-if="offertaShow">
					<ul  class="mt-2 mb-0 list-unstyled result-marker">
						<li v-for="itemchecklist in this.serviceOffers" :key="itemchecklist.id" class="d-flex align-items-center flex-wrap offersitem" :class="[{'text-primary':itemchecklist.STATUS == 'В работе' || itemchecklist.STATUS == 'Новая услуга'},{'text-danger':itemchecklist.STATUS == 'В архиве'},
								{'text-warning':itemchecklist.STATUS == 'На контроле'},{'text-success':itemchecklist.STATUS == 'Сделка закрыта'}]">
							<span class="mr-2">{{ $GVO.convertDateTimeFromMysqlToDate(itemchecklist.date_offer) }}</span>	
							<span class="mr-2">{{ $GVO.number_format(itemchecklist.amount,0,'.',' ') }} ₽</span>	
							<a class="mr-2" style="word-break: break-word;" :href="'/data/clients/id/'+itemchecklist.client_id+'?phoneint='+itemchecklist.phone" > {{itemchecklist.name}}</a>
							<span class="mr-2 text-success" v-if="itemchecklist.date_accept && itemchecklist.date_accept!=''">Принято {{ $GVO.convertDateTimeFromMysqlToDate(itemchecklist.date_accept) }}</span>	
							
							<span class="ml-auto">{{ itemchecklist.success_date }}</span>	
						</li>
						<!-- <span>service_id {{ itemchecklist.service_id }}</span> -->
					</ul>	
				</div>	
				
			</div>

			<div class="service-row" v-if="typeof objService.SERVICES_OBJ !='undefined' && typeof objService.SERVICES_OBJ.data !='undefined' && objService.SERVICES_OBJ.data.length>0">
				<!-- Артем Сосновский 17/06/2021 12:24 : 1 сулуга = 1 объект, я тебе говорил -->
				<h6 class="mr-3 mb-0">Объект: </h6>
				<div class="">
					<div class="row-no-wrap">
						<p class="mb-0">{{objService.SERVICES_OBJ.data[0].obj_id}}</p>
						<base-button 
							@click="GoToObjectEdit(objService.SERVICES_OBJ.data[0])" 
							type="primary"
							class="no-border my-0 ml-1"
							simple
							icon
						>
						<i class="d-inline-block tim-icons icon-pencil"></i>
						</base-button>
					</div>
				</div>			
			</div>

		</div>
		<template v-slot:footer>
			<div>
				<div class="ReCardServiceView_footer">
					<div class="status d-flex w-100 mt-2">
							<h4 class="mr-2 mb-1" :class="[{'text-primary':objService.STATUS == 'В работе' || objService.STATUS == 'Новая услуга'},{'text-danger':objService.STATUS == 'В архиве'},
								{'text-warning':objService.STATUS == 'На контроле'},{'text-success':objService.STATUS == 'Сделка закрыта'}]">{{objService.STATUS}}
							</h4>
							<!--
							nopurpose_text {{ objService.nopurpose_text }}
							nopurpose_descr {{ objService.nopurpose_descr }}
							-->						
							
							<!--
							<h4 v-if="objService.nopurpose_text != 'Другое' && (objService.STATUS == 'На контроле' || objService.STATUS == 'В архиве')" class="text-warning mb-1 ">{{objService.nopurpose_descr}}</h4>
							-->
							<h4 v-if="objService.nopurpose_text != 'Другое' && (objService.STATUS == 'На контроле' || objService.STATUS == 'В архиве')" class="text-warning mb-1 ">{{objService.nopurpose_text}}</h4>
							<h4 v-if="objService.nopurpose_text == 'Другое' && (objService.STATUS == 'На контроле' || objService.STATUS == 'В архиве')" class="text-warning mb-1 ">{{objService.nopurpose_descr}}</h4>
						<!--button class="btn btn-simple btn-primary" @click="GoToTaskEndEdit()" v-show="objService.editable==1" v-if="objService.STATUS!='На контроле' && objService.STATUS!='Сделка закрыта'">Редактировать потребности</button-->
						<div class="ml-md-2">
							<button class="btn btn-simple btn-warning " 
							@click="ShowNoPurposeForm()" 
							:disabled="typeof objNoPurposeGrouped =='undefined'" 
							v-show="objService.editable==1" v-if="(objService.STATUS!='На контроле' && objService.STATUS!='Сделка закрыта') && (objService.agrm_number==''||objService.agrm_type==2)">Не целевой</button>
							<button class="btn btn-simple btn-primary " 
							@click="alternative_start()" 
							v-if="objService.STATUS=='В архиве' && (objService.alternative_start!=undefined && objService.alternative_start == true)">Перезапустить услугу</button>

							<button class="btn btn-simple btn-success mr-2" @click="ToWork()" v-if="
							(objService.STATUS=='На контроле' || (objService.STATUS=='В архиве' && objService.archive_restore==1 && objService.agrm_type!=3)) && objService.subordinate_service==1">В работу</button>

							<button class="btn btn-simple btn-danger" @click="ToArchive()" v-if="objService.STATUS=='На контроле' && objService.subordinate_service==1">В отказ</button>
						</div> 
						<!--	:disabled="objNoPurposeGrouped.length==0 || typeof objNoPurposeGrouped !='undefined'"  -->
					</div>

					<div class="nopurposeform" v-if="bShowNopurposeForm">
						<el-select
							class="w-100 select-primary"
							size="large"
							placeholder="Выберите из списка"
							v-model="objNoPurpose.selectedVal"
							@change="onCh"
						>
							<el-option
								v-for="(el_opt, el_index) in objNoPurposeGrouped"
								class="select-primary"
								:value="el_opt.BP_NP_ID"
								:label="el_opt.opt_text"
								:key="el_index"
							>
							</el-option>
							<!-- <el-option
								v-for="(el_opt, el_index) in objNoPurpose.options"
								class="select-primary"
								:value="el_opt.value"
								:label="el_opt.label"
								:key="el_index"
							>
							</el-option> -->
						</el-select>
						<div class="w-100" v-if="bShowOtherTextArea">
							<div class="form-group">
								<div class="mb-0">
									<textarea class="form-control" v-model.lazy="objNoPurpose.descr" placeholder="Другое"></textarea>
								</div>
							</div>
						</div>
						<div class="btnGroup mt-3">
							<button class="btn btn-simple btn-success" @click="SaveNoPurposeForm()">Сохранить</button>
							<button class="btn btn-simple btn-danger" @click="ShowNoPurposeForm()">Отменить</button>
						</div>
					</div>

				</div> 


				<div class="manual_retrying" v-if="objService.STATUS!='На контроле' && objService.STATUS!='Сделка закрыта' && objService.STATUS != 'В архиве' && objService.editable==1">
					<collapse class="w-100 border-right-0" ref="manualRetry">
						<collapse-item title="Добавить задачу" @activate="getManualRetrying" id="manual_retrying" :activeIndex="activeCl">
							<div v-if="masManualRetrying.length>0">
								<ul class="list-unstyled">
									<li v-for="ret in masManualRetrying" class="d-flex mb-1">
										<button :class="[{'disabled':retryProcess==true},'btn btn-simple btn-success w-100']" @click="DoRetry(ret)">{{ret.name}}</button>
									</li>
								</ul>
							</div>
							<p v-else>Результататов нет</p>
						</collapse-item>
					</collapse>
				</div>
				
				<div class="crud-container comments" v-if="objService.editable==1">
					<collapse class="w-100 border-right-0">
						<collapse-item title="Комментарии к услуге" @activate="getDopFields('collapse',$event)" :activeIndex="activeDF">
							<ReCRUDFields v-model="masDopFields" :obj_type="'services'" :obj_id="objService.id" @change="getDopFields" />
						</collapse-item>
					</collapse>
				</div>
				<div class="crud-container documents" v-if="objService.editable==1">
					<collapse class="w-100 border-right-0">
						<collapse-item title="Документы" @activate="activeDocs=1" :activeIndex="activeDocs">
							<ReServiceDoc :service_id="objService.id" :show="activeDocs!=-1"/>
						</collapse-item>
					</collapse>
				</div>			
				<div class="crud-container" v-if="objService.editable==1">
					<collapse class="w-100 border-right-0">
						<collapse-item title="Дочерние услуги" :activeIndex="activeChild">
							<ul class="list-unstyled result-marker " v-if="objService.CHILD_SERVICES.length > 0">
								<li class="mb-0" v-for="childService in objService.CHILD_SERVICES" :key="childService.id"> Дочерняя услуга: <span class="mb-0 ml-2">{{childService.BP_NAME}} (ID услуги: {{childService.id}})</span></li>	
							</ul>
							<!-- <div class="oneline row mb-3 px-3" v-if="objService.CHILD_SERVICES.length > 0">
								<h6 class="mr-3 mb-0" v-for="childService in objService.CHILD_SERVICES" :key="childService.id"> Дочерняя услуга: <span class="mb-0 ml-2">{{childService.BP_NAME}} (ID услуги: {{childService.id}})</span></h6>	
							</div> -->
						</collapse-item>
					</collapse>
				</div>
			</div>
		</template>
	</card>
</template>

<script>
// import ReTagGroupList from "src/our_components/ReTagGroupList.vue";
import ReInputSearchDrop from "src/our_components/ReInputSearchDrop.vue";
import { Select, Option, /*Tooltip,*/ Button } from 'element-ui';
import { Collapse, CollapseItem } from 'src/components';
import ReClientNeeds from 'src/our_modules/SearchSendObjects/ReClientNeeds.vue';
import ReCRUDFields from 'src/our_components/ReCRUDFields.vue';
import ReSelectSovmestService from 'src/our_components/ReSelectSovmestService.vue';
import ReAgrmInfo from 'src/our_components/ReAgrmInfo.vue';
import ChecklistResult from 'src/our_components/checklist/ChecklistResult';
import swal from 'sweetalert2';
import ReBackTimer from "./ReBackTimer.vue";
import ReServiceDoc from "./ReServiceDoc.vue";

export default {
	name: "ReCardServiceView",
	components: {
		// ReTagGroupList,
		ReInputSearchDrop,
		[Option.name]: Option,
		[Select.name]: Select,
		Collapse, 
		CollapseItem,
		ReClientNeeds,
		// Tooltip,
		[Button.name]: Button,
		ReCRUDFields,
		ReSelectSovmestService,
		ReAgrmInfo,
		ChecklistResult,
		ReBackTimer,
		ReServiceDoc
	},
	props: {
		objService: Object,
		findId: {
			type: String,
			default: ""
		},
		objNoPurposeGrouped: [Object, Array],
		clientId: {
			type: String,
			default: '',
		}
	},
	watch: {
		objService(val){
			// this.bufferValue = this.$GVO.unlinkObject(val);
			this.getServiceOffers();
			this.serviceUpd(val);
			
		},

	},
	data() {
		return {
			ver: 1,
			retryProcess:false,
			masWatchers: [],
			bIsAgentEdit: false,
			agent_model: {
				inputText: this.objService.agent_name,
				selectedVal: this.objService.agent_id
			},
			agent_model_cache:{
				inputText: '',
				selectedVal: '',
			},
			agent_model_cache_previous:{
				inputText: '',
				selectedVal: '',
			},
			bShowNopurposeForm: false,
			objNoPurpose:{selectedVal:{},descr:'',options:[], default_sel: ''},
			bShowOtherTextArea: false,
			
			masManualRetrying:[],
			masManualData:{},
			activeCl: -1,

			objPotrebnostiFields:{
				'all':['rooms','district_ids','metro_ids','fin_purchase'],
				'15':['rooms','district_ids','metro_ids','fin_purchase'],
			},
			activeDF: -1,
			activeCh: -1,
			activeChild: -1,
			activeDocs: -1,
			masDopFields:[],
			bServicePartnerEdit:false,
			objSS:{'rb_choice':0,'masStaff':[]},
			BPCrumbs: [],
			// objChecklistData:{selectedVal:'',descr:'',options:[]},
			// hidebtnsClass: 'hidebtnsClass',
			offertaShow:false,
			serviceOffers: [],

		};
	},
	computed: {
		masPotrebnosti: function(){
			let masRet = [];
			let masFields = [];
			if(Object.keys(this.objPotrebnostiFields).indexOf(this.objService.BP_ID) != -1){
				masFields = this.objPotrebnostiFields[this.objService.BP_ID];
			}else{
				masFields = this.objPotrebnostiFields['all'];
			}
			if(masFields.length>0){
				for (let i = 0; i < masFields.length; i++) {
					if(typeof this.objService[masFields[i]] != 'undefined' && this.objService[masFields[i]] != ''){
						if(this.getPotrebnostiNormValue(masFields[i],this.objService[masFields[i]]) != '')
							masRet.push(this.getPotrebnostiNormValue(masFields[i],this.objService[masFields[i]]));
					}
				}
			}
			return masRet;
		},
		sellerServChecklist: function(){

						
			let slllerChecklist = [];
			slllerChecklist = JSON.parse(this.objService.extra_json);
			// console.log(slllerChecklist);
			return slllerChecklist;
		}
	},
	methods: {
		// getBPCrumbs(){
		// 	if (this.BPCrumbs.length==0){
		// 		this.$GVO.ApiCall('GET',{obj:'BP',flt:{'id':this.objService.BP_ID}})
		// 		.then((objApi) => {
		// 			//console.log(objApi);
		// 			if(objApi.success === true) {
		// 				this.BPCrumbs = objApi.data;
		// 			}
		// 		}).catch(errorObjApi => console.log(errorObjApi));
		// 	}
		// },
		// sellerServChecklist: function(){

								
		// let slllerChecklist = [];
		// slllerChecklist = JSON.parse(this.objService.extra_json);
		// // console.log(slllerChecklist);
		// return slllerChecklist;
		// },
		serviceUpd(val){

			// console.log(this.masManualData.serviceId, val.id)
			if(this.masManualData.serviceId && this.masManualData.serviceId != val.id){
				// console.log( this.masManualData.serviceId ,'clear masManual',val.id);
				this.masManualData = {};
				this.masManualRetrying = [];
				this.activeCl = -1;
				this.$refs.manualRetry.deactivateAll();
			}
		},
		deleteAgrm(data){
			
			// Тут бы ещё подтверждение запросить, а то вдруг микслик, а мы уже отязали

			swal({
				title: 'Удалить договор?',
				text: 'Вы точно хотите отвязать договор от услуги?',
				type: 'warning',
				showCancelButton: true,
				confirmButtonText: 'Да, отвязать',
				cancelButtonText: 'Нет',
				showCloseButton: true,
				showLoaderOnConfirm: true,
				buttonsStyling: false,
				focusConfirm: false,
				confirmButtonClass: 'btn btn-success btn-fill',
				cancelButtonClass: 'btn btn-danger btn-fill',
			}).then(result=>{
				if(result.value) {

					this.$GVO.ApiCall('DEL_AGRM',{obj:'services',flt:{'id':data.id, agrm_number: data.agrm_number}})
						.then((objApi) => {
							//console.log(objApi);
							if(objApi.success === true) {
								data.agrm_number='';
							}
						}).catch(errorObjApi => console.error(errorObjApi));	
				}
			})		
		},
		getPotrebnostiNormValue(valType,value){
			let masResult = [];
			switch (valType) {
				case 'rooms':
					masResult = this.getPotrebnostiCatNormValue(value.split(','),'CAT_ROOMS');
					break;
				case 'district_ids':
					masResult = this.getPotrebnostiCatNormValue(value.split(';'),'CAT_DIST','name_tr');
					break;
				case 'metro_ids':
					masResult = this.getPotrebnostiCatNormValue(value.split(';'),'CAT_METRO');
					break;
				case 'fin_purchase':
					if(parseFloat(value) > 0)
						masResult.push(this.$GVO.formatAmount(parseFloat(value)));
					break;
				default:
					break;
			}
			return masResult.join(', ');
		},
		getPotrebnostiCatNormValue(masData,cat_name,cat_key){
			let masResult = [];
			for (let i = 0; i < masData.length; i++) {
				if(masData[i] != ''){
					let v = this.$GVO.GetCatValName(cat_name,masData[i],cat_key);
					if(v != false){
						masResult.push(v);
					}else{
						masResult.push(masData[i]);
					}
				}						
			}
			return masResult;
		},
		DoRetry(taskData){
			if(this.retryProcess)
				return;
			//console.log(taskData);
			this.retryProcess=true;
			let SGVO=this.$GVO
			SGVO.ApiCall('MANUAL_RETRYING',{obj:'services',iData:{'service_id':this.objService.id,'client_id':this.$route.params.client_id,'BP_TASK_ID':taskData.id}})
				.then((objApi) => {
					this.retryProcess=false;
					//console.log(objApi);
					if(objApi.success === true) {
						SGVO.showAlert('Задача','Задача добавлена','btn btn-success btn-fill');
					}
				}).catch(errorObjApi => {
					this.retryProcess=false;
					return console.error(errorObjApi)
				});
		},
		getManualRetrying(bCollapseOpen){
			//console.log(bCollapseOpen);
			if (this.masManualRetrying.length==0){
				let serviceId = this.objService.id;
				let bpId = this.objService.BP_ID;
				this.$GVO.ApiCall('GET_MANUAL_RETRYING',{obj:'services',flt:{'BP_ID':bpId,'id':serviceId}})
				.then((objApi) => {
					//console.log(objApi);
					if(objApi.success === true) {
						this.masManualRetrying = objApi.data;
						this.masManualData={
							serviceId,
							bpId
						}
					}
				}).catch(errorObjApi => console.error(errorObjApi));
			}
		},
		getDopFields(data,bCollapseOpen=true){
			if(data===true)this.masDopFields = [];
			//console.log(data,bCollapseOpen);
			if (this.masDopFields.length==0 && bCollapseOpen===true){
				this.$GVO.ApiCall('addons_fields.GET',{flt:{'obj_type':'services','obj_id':this.objService.id}})
				.then((objApi) => {
					// console.log(objApi);
					if(objApi.success === true) {
						for (let i = 0; i < objApi.data.length; i++) {
							const element = objApi.data[i];
							this.masDopFields.push({
								id: element.id,
								field_type: element.field_type,
								name: element.name,
								elements: [{
									elementGetParamMap: 'crud_input',
									element_model: element.val,
									elementType: 'input',
									placeholder: 'Пиши в меня',
								}]
							});
						}
					}
				}).catch(errorObjApi => console.error(errorObjApi));
			}
		},
		ToWork(){
			this.$GVO.ApiCall('SET_SERVICE_BACK2WORK',{obj:'services',flt:{'service_id':this.objService.id}})
				.then((objApi) => {
					// console.log(objApi);
					if(objApi.success === true) location.reload();
				}).catch(errorObjApi => console.error(errorObjApi));
		},
		ToArchive(){
			this.$GVO.ApiCall('SET_SERVICE_TO_ARCHIVE',{obj:'services',flt:{'service_id':this.objService.id}})
				.then((objApi) => {
					// console.log(objApi);
					if(objApi.success === true) location.reload();
				}).catch(errorObjApi => console.error(errorObjApi));
		},
		onCh(evt){
			// console.log(evt);
			this.objNoPurpose.descr = '';
			if(typeof this.objNoPurposeGrouped !='undefined'){
				for (let i = 0; i < this.objNoPurposeGrouped.length; i++) {
					if(this.objNoPurposeGrouped[i].BP_NP_ID == evt){
						if(this.objNoPurposeGrouped[i].opt_text == 'Другое'){
							this.bShowOtherTextArea = true;
						}else{
							this.bShowOtherTextArea = false;
						}
					}				
				}
			}

			// for (let i = 0; i < this.objNoPurpose.options.length; i++) {
			// 	if(this.objNoPurpose.options[i].value == evt){
			// 		if(this.objNoPurpose.options[i].label == 'Другое'){
			// 			this.bShowOtherTextArea = true;
			// 		}else{
			// 			this.bShowOtherTextArea = false;
			// 		}
			// 	}				
			// }
		},
		UpdateWatchers(masWatchers) {
			// console.log("UpdateWatchers", masWatchers);
			//АПИ запрос на обновление наблюдателей
		},
		GoToEdit(strType, id) {
			if (strType == "agent") {
				this.bIsAgentEdit = true;
				this.agent_model.inputText = '';
				this.agent_model.selectedVal = '';
				
			}
			if (strType == "SERVICES_PARTNER") {
				this.bServicePartnerEdit = true;
			}
		},
		CancelSovmestService(){
			this.bServicePartnerEdit = false;
		},
		GoToObjectEdit(obj){
			this.$router.push({path: '/data/clients/id/'+this.$route.params.client_id+'/object/edit?obj_id='+obj.obj_id+'&service_id='+obj.service_id+'&id='+obj.id});
		},
		GoToTaskEndEdit() {
			this.$GVO.ApiCall('GET_FORM_TASKEND_CHECKLISTIDS',{obj:'services',flt:{'service_id':this.objService.id}})
				.then((objApi) => {
					if(objApi.success === true && objApi.data.length>0){
						//console.log(typeof objApi.data);
						this.$router.push({path: '/data/service/id/'+this.objService.id+'/task-end/id/'+objApi.data[0].taskend_id+'/edit?client_id='+objApi.data[0].client_id+'&task_id='+objApi.data[0].task_id});
					}else{
						//alert('Задачи "выявить потребности" ещё не было назначено');
						alert('Задача "Выявить потребности" ещё не выполнена');
					}
				}).catch(errorObjApi => console.error("hoho " + errorObjApi));
		},
		onAgentChange(evt){
			this.agent_model_cache_previous = this.agent_model_cache;
			this.agent_model_cache = evt;
		},
		onSave() {
			if (this.agent_model.selectedVal != "" && this.agent_model_cache.inputText==this.agent_model.inputText) {
				
				this.$GVO.ApiCall("UPD_SRV_CURATOR", {obj: "services", flt:{ service_id: this.objService.id }, uData:{ agent_id: this.agent_model, agent_id_old: this.agent_model_cache_previous} })
					.then(objApi => {
						//console.log(objApi);
						if (objApi.success === true) {
							this.bIsAgentEdit = false;
							
							this.objService.agent_name = this.$GVO.unlinkObject(this.agent_model.inputText);
							this.objService.agent_id = this.$GVO.unlinkObject(this.agent_model.selectedVal);
							
							location.reload();
						}
					})
					.catch(errorObjApi => {
						this.$GVO.showAlert('Ответственный','Ошибка смены ответсвенного!');
						this.bIsAgentEdit = false;
					});
				
			} else {
				//alert("Ответственный должен быть заполнен!");
				this.$GVO.showAlert('Ответственный','Ответственный должен быть заполнен!');
			}
		},
		onCancel() {
			location.reload();
		},
		ShowNoPurposeForm(){
			this.bShowNopurposeForm = !this.bShowNopurposeForm;
		},
		offertaShowMe(){
			this.offertaShow = !this.offertaShow;
			// this.getServiceOffers();
		},
		GetNoPurposeDefault(){
			if(typeof this.objNoPurposeGrouped !='undefined'){
				for (let i = 0; i < this.objNoPurposeGrouped.length; i++) {
					if(this.objNoPurposeGrouped[i].is_default != -1 && this.objNoPurposeGrouped[i].is_default != ''){
						//console.log(this.objNoPurposeGrouped[i]);
						//this.objNoPurpose.selectedVal = this.objNoPurposeGrouped[i].opt_text;
						this.objNoPurpose.selectedVal = this.objNoPurposeGrouped[i].BP_NP_ID;//{value:this.objNoPurposeGrouped[i].BP_NP_ID, label:this.objNoPurposeGrouped[i].opt_text};
						this.onCh(this.objNoPurpose.selectedVal);
					}	
				}
			}
		},
		// GetNoPurposeOptions(){
		// 	if(this.objService.editable==1 && this.objService.STATUS!='На контроле' && this.objService.STATUS!='Сделка закрыта'){
		// 		this.$GVO.ApiCall('GET_NOPURPOSE_SEL_FIELDS',{obj:'BP',flt:{'bp_id':this.objService.BP_ID}})
		// 		// this.$GVO.ApiCall('GET_NOPURPOSE_SEL_FIELDS',{obj:'BP',flt:{'bp_id':'all'}})
		// 			.then((objApi) => {
		// 				if(objApi.success === true){
		// 					this.objNoPurpose.options = objApi.data.options;
		// 					if(objApi.data.default_sel != -1 && objApi.data.default_sel != ''){
		// 						this.objNoPurpose.selectedVal = objApi.data.default_sel;
		// 						this.onCh(this.objNoPurpose.selectedVal);
		// 					}
		// 				}
		// 			}).catch(errorObjApi => console.log(errorObjApi));
		// 	}
		// },
		SaveNoPurposeForm(){
			if(this.objNoPurpose.selectedVal==''){
				this.$GVO.showAlert('Ошибка заполнения полей','Необходимо заполнить обязательное поле: причина перевода в не целевой');
				return false;
			}
			//let uData={nopurpose_id:this.objNoPurpose.selectedVal,nopurpose_text:'',nopurpose_descr:this.objNoPurpose.descr};
			
			let uData={nopurpose_id:this.objNoPurpose.selectedVal,nopurpose_text:'',nopurpose_descr:this.objNoPurpose.descr};
			if (uData.nopurpose_descr==''){uData.nopurpose_descr=this.objNoPurpose.selectedVal;}
			
			if(typeof this.objNoPurposeGrouped !='undefined'){
				for (let i = 0; i < this.objNoPurposeGrouped.length; i++) {
					if(this.objNoPurposeGrouped[i].BP_NP_ID == this.objNoPurpose.selectedVal){
						uData.nopurpose_text = this.objNoPurposeGrouped[i].opt_text;
					}
				}
				// for (let i = 0; i < this.objNoPurpose.options.length; i++) {
				// 	if(this.objNoPurpose.options[i].value == this.objNoPurpose.selectedVal){
				// 		uData.nopurpose_text = this.objNoPurpose.options[i].label;
				// 	}				
				// }
				this.$GVO.ApiCall('SET_NOPURPOSE',{obj:'services',flt:{'id':this.objService.id},'uData':uData})
				.then((objApi) => {
					if(objApi.success === true){
						location.reload();
					}
				}).catch(errorObjApi => console.error(errorObjApi));
			}
		},
		GoToHistory(){
			this.$router.push({path: '/data/services/id/'+this.objService.id+'/history'});
		},
		makeMeInCharge(){

		},
		SaveSovmestService(){
			this.$GVO.ApiCall('services.UPD_SERVICES_PARTNER',{flt:{'service_id':this.objService.id},'uData':{ss_id:this.objSS}})
				.then((objApi) => {
					if(objApi.success === true){
						location.reload();
					}
				}).catch(errorObjApi => console.error(errorObjApi));
		},
		getServiceOffers(){
			//SGVO.ApiCall("GET_SERVICE_OFFER",{"obj":"CHECKLIST_OFFER","flt":{"service_id":9353}})
			let count = 0;
			count ++;

			this.$GVO.ApiCall('GET_SERVICE_OFFER',{obj:'CHECKLIST_OFFER',flt:{'service_id':this.objService.id}})
				.then((objApi) => {
					if(objApi.success === true){

						this.serviceOffers = objApi.data;
						// console.log('offers', this.serviceOffers);
						// if(element.doc==undefined){
						// 	// console.log('element.doc==undefined');
						// } else {
						// 	// console.log('element.doc', element.doc);
						// 	element.doc = JSON.parse(element.doc);
						// }
						// this.masChecklistData.push({
						// 		descr:element.descr,
						// 		link:element.link,
						// 		name:element.name,
						// 		// checklist_id:element.id,
						// 		checklist_id:element.checklist_id,
						// 		doc:element.doc,
						// 	});							

						// this.hidebtnsClass = ''; 

					}
				}).catch(errorObjApi => console.error(errorObjApi));
				// console.log('count',count);
		},
		alternative_start(){
			// console.log('А что должна делать эта кнопка?');
		}
		
	},
	mounted(){
		//this.GetNoPurposeOptions();
		this.agent_model_cache_previous = {
			inputText: this.objService.agent_name,
			selectedVal: this.objService.agent_id
		};
		if(this.objService.SERVICES_PARTNER.length>0){
			this.objSS = {'rb_choice':'1','masStaff':[]};
			for (let i = 0; i < this.objService.SERVICES_PARTNER.length; i++) {
				const agent = this.objService.SERVICES_PARTNER[i];
				this.objSS.masStaff.push({'label':agent.agent_name,'value':agent.agent_id});
			}
		}
		this.GetNoPurposeDefault();
		this.getServiceOffers();
		
	},
	created(){
		// this.getBPCrumbs();
		// if(this.objNoPurpose.options.length == 0)
		// 	this.GetNoPurposeOptions();
	}
};
</script>
<style scoped>

.ReCardServiceView .oneline > * {
	display: inline-block;
}

.ReCardServiceView .oneline-serv {
	display: flex;
	align-items: center;
}
.ReCardServiceView_footer {
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	align-items: center;	
}
.ReCardServiceView_footer label {
	color: blueviolet;
}
.ReCardServiceView_footer > button {margin: 4px 2px;}

.editBtns {
	/*
	position: absolute;
	right: -5px;
	*/
	top: -5px;
	position: relative;
	width: 100px;
}
.risd {
	width: calc(100% - 80px);
}
.white-content .card:not(.card-white) .lightTheme {background:  #f1f6fc!important; box-shadow: 0px 3px 10px 0px rgba(123, 123, 123, 0.25); border: 1px solid #9e77f3;}
.ReCardServiceView {border: 1px solid #9e77f3;}
.card-warning {box-shadow: 0 1px 15px 0 rgba(123, 123, 123, 0.08); border: 1px solid #ff8d72!important;}
.card-danger {box-shadow: 0 1px 15px 0 rgba(123, 123, 123, 0.08)!important; border: 1px solid #f84e54!important;}
.ReCardServiceView .col-md-6 {padding-left: 0;}

.nopurposeform{
	width: 100%;
	margin: 15px 0;
	padding: 15px;
	border: 1px solid #2b3553;
	border-radius: 6px;
}

.white-content .nopurposeform {border-color: rgba(29, 37, 59, 0.5)}

.nopurposeform textarea{
	margin: 15px 0;
}
.nopurposeform .btnGroup, .status{
	display: flex;
	justify-content: space-between;
	align-items: center;
}
/*.status p:first-child {color: #ff8d72;}*/
.ReCardServiceView .BP-row {display: flex; flex-wrap: wrap; justify-content: flex-start; align-items: center;}
.ReCardServiceView .BP-id-serviceView {min-width: 70px;}
.row-no-wrap {display: flex; align-items: center;}

/* .el-button {background: transparent!important; padding: 0!important;} */

.specBtns{
	position: absolute;
	z-index: 1;
	right: 10px;
	top: 8px;
}
.ReCardServiceView >>> .card-header {padding-bottom: 0px!important;}
.ReCardServiceView >>> .crud-container .card-body {padding-left: 0px!important; padding-right: 0px!important;}
.ReCardServiceView >>> .card-body {padding-bottom: 0px!important;}
.ReCardServiceView >>> .card-footer {padding-top: 0px!important;}
.ReCardServiceView >>> .BPSTAGES-row {display: flex; flex-wrap: wrap; align-items: baseline;}
.ReCardServiceView >>> .BPSTAGES {position: relative; margin-right: 20px;}
.ReCardServiceView >>> .BPSTAGES:not(:last-child) p::after{
	content: '>';
	position: absolute;
	right: -15px;
	top: 0 ;
}

.ReCardServiceView >>> .service-row {display: flex; align-items: baseline; flex-wrap:wrap; margin-bottom: 5px; /*height: 38px; */}
.ReCardServiceView >>> .service-container {display: flex; flex-direction: column;}

.ReCardServiceView >>> .oneline .el-tag {width: fit-content;}

.ReCardServiceView >>> .itemchecklistStyles {
	border: 1px dashed #01b0e0;
    border-radius: 6px;
    padding: 10px;
}

.ReCardServiceView >>>  .offersitem:not(:last-child) {border-bottom: 1px dashed rgb(1, 176, 224);margin-bottom: 5px; padding-bottom: 5px;}
.ReCardServiceView >>>  .offersitem:last-child {margin-bottom: 0px;}
.ReCardServiceView >>>  .ReInputSearchDrop-container {width: 100%;}

@media (max-width: 1557px) {
	.ReCardServiceView .oneline-serv {
		align-items: flex-start;
	}
}

@media (max-width: 1020px) {
	.ReCardServiceView .nopurposeform {display: flex; flex-direction: column;}
	.ReCardServiceView .nopurposeform .btnGroup {flex-wrap:wrap;}
	.ReCardServiceView .ReCardServiceView_footer .btn{width: 100%;}
	
}
@media (max-width: 1040px) {
	.ReCardServiceView .duty {display: flex; flex-wrap: wrap;}
}

@media (max-width: 576px) {
	.ReCardServiceView .d-flex {flex-direction: column;}
	
}
@media (max-width: 786px) {
	.manual_retrying, .comments  {margin-bottom: 15px;}
	.manual_retrying  {margin-top: 15px;}
	.manual_retrying .card-collapse .card:not(.card-cinc) .card-header {font-size: 16px;}/**/
	/* .ReCardTask .nav-pills .nav-item .nav-link {padding: 5px 11px;} */
}

</style>
